import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_ed2227e8-f42f-486d-80b3-32e833e48098/artifacts/o750zne6_72B3D45F-1688-469F-935E-BB6BB3789CC9.png";

const LINKS = [
  { href: "#services", label: "Services" },
  { href: "#pricing", label: "Pricing" },
  { href: "#gallery", label: "Work" },
  { href: "#testimonials", label: "Reviews" },
  { href: "#faq", label: "FAQ" },
  { href: "#contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-[#050B14]/80 border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 md:px-12 py-4">
        <a href="#top" className="flex items-center gap-3" data-testid="navbar-logo">
          <img src={LOGO} alt="Capital Shield" className="h-11 w-11 object-contain" />
          <div className="leading-tight">
            <div className="font-display text-lg font-bold tracking-wide text-white">
              CAPITAL SHIELD
            </div>
            <div className="text-[10px] tracking-[0.25em] uppercase text-[#9BD0E8]">
              Sealing · Snow Removal
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm text-white/80 hover:text-[#C9A24B] transition-colors duration-200"
              data-testid={`nav-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#pricing"
          data-testid="navbar-cta-quote"
          className="hidden md:inline-flex items-center px-5 py-2.5 bg-[#C9A24B] hover:bg-[#E0B962] text-[#050B14] font-semibold text-sm tracking-wide transition-colors duration-200"
        >
          Book Online
        </a>

        <button
          className="md:hidden text-white p-2"
          onClick={() => setOpen((s) => !s)}
          aria-label="Toggle menu"
          data-testid="navbar-mobile-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-[#050B14]/95 backdrop-blur-xl">
          <div className="px-6 py-4 flex flex-col gap-4">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-white/85 text-sm py-2"
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href="#quote"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center px-5 py-3 bg-[#C9A24B] text-[#050B14] font-semibold text-sm tracking-wide"
              data-testid="mobile-navbar-cta-quote"
            >
              Get a Free Quote
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
